// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import Select, { components } from 'react-select';

class State {
  data = [];
  airports = [];
  selectValue = '';
  currentAirport = {};
  open = false;
}

export default class ElementSelector extends Component {
  state = new State();

  singleOption = props => (
    <components.Option {...props}>
      {props.data.icon && (
        <img
          src={props.data.icon}
          alt='test'
          style={{ width: '20px', height: '20px' }}
        />
      )}
      {`    ${props.label}`}
    </components.Option>
  );

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { options, value, placeholder, onChange, isDisabled } = this.props;
    return (
      <div style={{ marginBottom: '20px' }}>
        <Select
          placeholder={placeholder}
          components={{
            DropdownIndicator: () => (
              <Glyphicon
                style={{ color: '#c4c4c4', paddingRight: '10px' }}
                glyph='chevron-down'
              />
            ),
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
            Option: this.singleOption,
          }}
          styles={{
            menu: styles => ({ ...styles, zIndex: 4000 }),
            control: styles => ({
              ...styles,
              '&:focus': {
                borderColor: '#4496d8',
                boxShadow: 'none',
                outline: '0',
              },
            }),
          }}
          isClearable
          isSearchable
          openMenuOnClick
          value={value}
          onChange={onChange}
          options={options}
          isDisabled={isDisabled}
        />
      </div>
    );
  }
}
